import type { PropsWithChildren } from "react";
import { nyBestillingConfig } from "../config/nyBestillingConfig";
import { usePersistantState } from "../hooks";
import {
  BestillingContext,
  type BestillingContextDataType,
} from "./bestillingContext";

export function BestillingProvider({ children }: PropsWithChildren) {
  const initBestillingData: BestillingContextDataType = {
    leverandoerOrgNr: null,
    aktoer: null,
    avtalePeriode: null,
    bestillerPrivat: null,
    bestillerSelskap: null,
    vilkårAkseptert: null,
  };
  const [bestillingData, setBestillingData] =
    usePersistantState<BestillingContextDataType>(
      nyBestillingConfig.storageKey,
      initBestillingData,
      nyBestillingConfig.storageType,
    );

  return (
    <BestillingContext.Provider
      value={{
        bestilling: bestillingData,
        setBestillingData: (bestillingData: BestillingContextDataType) =>
          setBestillingData(bestillingData),
        resetBestillingData: () => setBestillingData(initBestillingData),
        readOnly: false,
      }}
    >
      {children}
    </BestillingContext.Provider>
  );
}
